import * as React from "react";
import Button from "@material-ui/core/Button";
import AddSubscribedOrganisationsDialog from "./AddSubscribedOrganisationsDialog";
import RemoveSubscriptionDialog from "./RemoveSubscriptionDialog";
import SubscribedOrganisationList from "../../generic/SubscribedOrganisationList";
import { SubscribedOrganisationRateCardPartialOrganisation as PartialOrganisation } from "./__generated__/SubscribedOrganisationRateCardPartialOrganisation";
import { withStyles } from "@material-ui/core/styles";
import { StyleProps } from "../../types";
import { Publish, Unsubscribe } from "@material-ui/icons";

const styles = (theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
  buttonContainer: {
    display: `flex`,
    flexDirection: `row` as const,
    marginTop: theme.spacing(1),
  },
  root: {
    display: `flex`,
    flex: 1,
    flexDirection: `column` as const,
    marginTop: theme.spacing(1),
  },
});

export type EnhancedProps = {
  rateCardID: string | null | undefined;
  activeItems?: PartialOrganisation[];
  activeItemsLoading: boolean;
  addSubscriptionsDialogOpen: boolean;
  availableItems: PartialOrganisation[];
  availableItemsLoading: boolean;
  confirmUnsubscribeDialogOpen: boolean;
  onActivatePressed: () => void;
  onDeactivatePressed: () => void;
  setAddSubscriptionsDialogOpen: (dialogOpen: boolean) => void;
  setConfirmUnsubscribeDialogOpen: (dialogOpen: boolean) => void;
  setSubscribingOrganisationID: (selectIds: string[]) => void;
  setUnsubscribingOrganisationID: (selectIds: string[]) => void;
  subscribingOrganisationID: string[];
  unsubscribingOrganisationID: string[];
};

type Props = EnhancedProps & StyleProps;

/**
 * This Class will be wrapped with SubscribedOrganisationData which will provide
 * all the curation functionality for each organisation.
 */
class SubscribedOrganisationLayout extends React.Component<Props> {
  render() {
    const {
      activeItems,
      activeItemsLoading,
      addSubscriptionsDialogOpen,
      availableItems,
      availableItemsLoading,
      rateCardID,
      classes,
      confirmUnsubscribeDialogOpen,
      setAddSubscriptionsDialogOpen,
      setConfirmUnsubscribeDialogOpen,
      setUnsubscribingOrganisationID,
      setSubscribingOrganisationID,
      subscribingOrganisationID,
      unsubscribingOrganisationID,
      onDeactivatePressed,
      onActivatePressed,
    } = this.props;

    return (
      <div className={classes.root}>
        <SubscribedOrganisationList
          emptyMessage={
            rateCardID == null
              ? `Select a rate card`
              : `Rate card has not been published`
          }
          selectedIDs={unsubscribingOrganisationID}
          subscribedOrganisations={activeItems}
          loading={activeItemsLoading}
          title="Rate card has been published to:"
          onSelectedIDsChange={setUnsubscribingOrganisationID}
        />

        <div className={classes.buttonContainer}>
          <Button
            className={classes.button}
            color="secondary"
            disabled={unsubscribingOrganisationID.length === 0}
            onClick={() => setConfirmUnsubscribeDialogOpen(true)}
            startIcon={<Unsubscribe />}
          >
            Unpublish
          </Button>

          <AddSubscribedOrganisationsDialog
            availableItems={availableItems}
            availableItemsLoading={availableItemsLoading}
            setSubscribingOrganisationID={setSubscribingOrganisationID}
            subscribingOrganisationID={subscribingOrganisationID}
            open={addSubscriptionsDialogOpen}
            onActivatePressed={onActivatePressed}
            onClose={() => setAddSubscriptionsDialogOpen(false)}
          />

          <Button
            className={classes.button}
            color="primary"
            disabled={rateCardID == null}
            onClick={() => setAddSubscriptionsDialogOpen(true)}
            startIcon={<Publish />}
            variant={"outlined"}
          >
            Publish
          </Button>
        </div>

        <RemoveSubscriptionDialog
          open={confirmUnsubscribeDialogOpen}
          onUnsubscribedPressed={onDeactivatePressed}
          onClose={() => setConfirmUnsubscribeDialogOpen(false)}
        />
      </div>
    );
  }
}

export default withStyles(styles)(SubscribedOrganisationLayout);
